import { RootState } from "../store";

export const selectDefect = (state: RootState) => state.defect;

export const selectDefects = (state: RootState) => state.defect.data;

export const selectDefectsLoading = (state: RootState) => state.defect.loading;

export const selectFilteredDefects = (state: RootState) => state.defect.filteredDefects;

export const selectActiveTab = (state: RootState) => state.defect.activeTab;

export const selectShowCloseDefectsDialog = (state: RootState) => state.defect.showCloseDefectsDialog;

export const selectShowShareDefectsDialog = (state: RootState) => state.defect.showShareDefectsDialog;

export const selectSelectedVessel = (state: RootState) => state.defect.selectedVessel;

export const selectInsightsFilterBy = (state: RootState) => state.defect.insightsFilterBy;
export const selectPscRiskFilterBy = (state: RootState) => state.defect.pscRiskFilterBy;

export const selectAuthorityMappings = (state: RootState) => state.defect.authorityMappings;

export const selectDefectCodes = (state: RootState) => state.defect.defectCodes;
export const selectRegimeMappings = (state: RootState) => state.defect.regimeMappings;
export const selectRegimeMappingsLoading = (state: RootState) => state.defect.regimeMappingsLoading;
export const selectRegimeDescriptions = (state: RootState) => state.defect.regimeDescriptions;
export const selectRegimeMappingsLoaded = (state: RootState) => state.defect.regimeMappingsLoaded;
export const selectRegimeMappingsError = (state: RootState) => state.defect.regimeMappingsError;
